import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=32347c98&scoped=true"
import script from "./audit.vue?vue&type=script&lang=js"
export * from "./audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32347c98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32347c98')) {
      api.createRecord('32347c98', component.options)
    } else {
      api.reload('32347c98', component.options)
    }
    module.hot.accept("./audit.vue?vue&type=template&id=32347c98&scoped=true", function () {
      api.rerender('32347c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/order/need-goods/audit/audit.vue"
export default component.exports